import { render } from "./RafToffee.vue?vue&type=template&id=dda241aa"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/RafToffee.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dda241aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dda241aa', __exports__)) {
    api.reload('dda241aa', __exports__)
  }
  
  module.hot.accept("./RafToffee.vue?vue&type=template&id=dda241aa", () => {
    api.rerender('dda241aa', render)
  })

}


export default __exports__